// Utility for managing stamprally condition icons
import { STAMP_ICON_BASE_URL } from '../config';

// Map condition combinations to icon identifiers (numbers 1-15)
const CONDITION_ICON_MAP = {
  // app/member
  'app_member_birthday': '1',
  'app_member_address': '3',
  'app_member_traffic_ic': '5',
  'app_member_push_notification': '7',
  
  // app/history
  'app_history_purchase_count': '9',
  'app_history_use_date_range': '11',
  'app_history_use_specific_date': '11',
  'app_history_use_time_range': '11',
  
  // app/achievement
  'app_achievement_point': '13',
  'app_achievement_coupon': '2',
  'app_achievement_action': '15',
  'app_achievement_view': '4',
  
  // qr
  'qr_spot_qr': '10',
  'qr_custom_qr': '10',
  
  // location
  'location_permission': '6',
  'location_area': '8'
};

/**
 * Get icon identifier based on condition type
 * @param {Object} condition - Condition object or modal settings
 * @returns {string|null} Icon identifier or null if not applicable
 */
export function getConditionIconIdentifier(condition) {
  if (!condition) return null;
  
  const { category, subCategory, settings } = condition;
  
  if (!category || !subCategory) return null;
  
  let key;
  
  if (category === 'app' && subCategory === 'achievement' && settings?.achievementType) {
    // For achievement, use achievementType
    key = `app_achievement_${settings.achievementType}`;
  } else if (category === 'app' && subCategory === 'member' && settings?.memberField) {
    // For member, use memberField
    key = `app_member_${settings.memberField}`;
  } else if (category === 'app' && subCategory === 'history' && settings?.historyType) {
    // For history, use historyType
    key = `app_history_${settings.historyType}`;
  } else {
    // For others, use category_subCategory
    key = `${category}_${subCategory}`;
  }
  
  return CONDITION_ICON_MAP[key] || null;
}

/**
 * Build full icon URL from identifier
 * @param {string} identifier - Icon identifier (number 1-15)
 * @returns {string} Full icon URL
 */
export function buildIconUrl(identifier) {
  if (!identifier) return '';
  return `${STAMP_ICON_BASE_URL}/${identifier}.png`;
}

/**
 * Get icon URL for a condition
 * @param {Object} condition - Condition object or modal settings
 * @returns {string|null} Full icon URL or null if not applicable
 */
export function getConditionIconUrl(condition) {
  const identifier = getConditionIconIdentifier(condition);
  if (!identifier) return null;
  return buildIconUrl(identifier);
}

/**
 * Check if condition has a valid icon configuration
 * @param {Object} condition - Condition object or modal settings
 * @returns {boolean} True if icon can be determined
 */
export function hasValidIcon(condition) {
  return !!getConditionIconIdentifier(condition);
}
